import { render, staticRenderFns } from "./orderInsureTable.vue?vue&type=template&id=252073e9&"
import script from "./orderInsureTable.vue?vue&type=script&lang=js&"
export * from "./orderInsureTable.vue?vue&type=script&lang=js&"
import style0 from "./orderInsureTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VDataTable,VLayout})
